<eda-dialog2 [display]="display" [header]="title" width="80vw" height="80vh"
  [disableApply]="!tableName || !delimiter || !csvHeaders" (apply)="generateTable()"
  (close)="closeDialog()">

  <div content class="flex gap-6 p-3 h-full">

    <!-- Left panel: form -->
    <div class="flex flex-col gap-4 w-72 shrink-0">

      <div>
        <label i18n="@@placeholderTableName" for="tablename" class="block text-sm font-medium text-gray-700 mb-1">Nombre de la tabla</label>
        <input
          id="tablename"
          type="text"
          [(ngModel)]="tableName"
          class="csv-input w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        />
      </div>

      <div>
        <label i18n="@@placeholderInputSeparator" for="separator" class="block text-sm font-medium text-gray-700 mb-1">Separador</label>
        <input
          id="separator" type="text" placeholder="," [(ngModel)]="delimiter"
          class="csv-input w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
          (keyup)="retryCsvWithNewSeparator()"
        />
      </div>

      <!-- Drag & Drop CSV -->
      <div (dragenter)="handleDragIn($event, 'csv')" (dragleave)="handleDragOut($event, 'csv')"
        (dragover)="handleDrag($event)" (drop)="handleDrop($event, 'csv')"
        class="relative flex h-36 cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed transition-colors"
        [class.csv-dragging]="isDraggingCsvFile() && delimiter"
        [class.border-gray-300]="!isDraggingCsvFile() || !delimiter"
        [class.csv-hover]="delimiter && !isDraggingCsvFile()">
        <input type="file" #file (change)="handleFileSelect($event, 'csv'); onFilesAdded()"
          class="absolute inset-0 z-50 h-full w-full cursor-pointer opacity-0"
          accept=".csv" />
        <div class="flex flex-col items-center justify-center text-sm pointer-events-none">
          <div *ngIf="_csvFileName(); else noFile">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="mx-auto mb-2 h-6 w-6 text-[var(--corporate-primary)]">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <p class="text-sm font-medium text-center text-gray-700">{{ _csvFileName() }}</p>
          </div>
          <ng-template #noFile>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="mx-auto mb-2 h-6 w-6 text-gray-400">
              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
            <p class="mb-1 text-sm font-medium text-gray-600 text-center">
              <span class="text-[var(--corporate-primary)]" i18n="@@clickToUpload">Click para subir</span>
              <span i18n="@@dragDrop"> o arrastra y suelta</span>
            </p>
            <p class="text-xs text-gray-500">CSV (max. 10MB)</p>
          </ng-template>
        </div>
      </div>

    </div>

    <!-- Divider -->
    <div class="w-px bg-gray-200 shrink-0"></div>

    <!-- Right panel: table -->
    <div class="flex-1 overflow-y-auto">
      <table class="w-full border-collapse text-sm">
        <thead>
          <tr class="bg-gray-50 border-b border-gray-200">
            <th class="px-4 py-3 text-left font-medium text-gray-600 w-1/4" i18n="@@csvField">Campo</th>
            <th class="px-4 py-3 text-left font-medium text-gray-600 w-1/4" i18n="@@type">Tipo</th>
            <th class="px-4 py-3 text-left font-medium text-gray-600 w-1/4" i18n="@@dateFormatH4">Formato</th>
            <th class="px-4 py-3 text-left font-medium text-gray-600 w-1/4" i18n="@@csvSep">Separador Decimal</th>
          </tr>
        </thead>
        <tbody>
          @for(row of csvColumns; track $index){
          <tr class="border-b border-gray-100 hover:bg-gray-50 transition-colors">
            <td class="px-4 py-2 text-gray-700 font-medium">{{ row.field }}</td>

            <td class="px-4 py-2">
              <p-dropdown class="csv-dropdown"
                [(ngModel)]="row.type"
                [ngModelOptions]="{standalone: true}"
                [options]="dataTypes"
                optionLabel="label"
                optionValue="value"
                [style]="{'width':'100%'}"
                appendTo="body">
              </p-dropdown>
            </td>

            <td class="px-4 py-2">
              @if(row.type === 'timestamp'){
                <p-dropdown class="csv-dropdown"
                  [(ngModel)]="row.format"
                  [ngModelOptions]="{standalone: true}"
                  [options]="dataFormats"
                  optionLabel="label"
                  optionValue="value"
                  [autoDisplayFirst]="true"
                  [style]="{'width':'100%'}"
                  appendTo="body">
                </p-dropdown>
              }
            </td>

            <td class="px-4 py-2">
              @if(['integer', 'numeric'].includes(row.type)){
                <p-dropdown class="csv-dropdown"
                  [(ngModel)]="row.separator"
                  [ngModelOptions]="{standalone: true}"
                  [options]="decSeparators"
                  optionLabel="label"
                  optionValue="value"
                  [autoDisplayFirst]="true"
                  [style]="{'width':'100%'}"
                  appendTo="body">
                </p-dropdown>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

  </div>

</eda-dialog2>
